const SPECIAL_CHARACTERS = Object.freeze({
    COMMA: ',',
    POINT: '.',
    COLON: ':',
    MINUS: '-'
})

export default SPECIAL_CHARACTERS;
